import React
// , {useEffect} 
from 'react';
// import { useParams } from 'react-router-dom';

const User = () => {
    
    // const username = useParams();

    // useEffect(() => {
    //     fetch(`https://api-skillshikhun.herokuapp.com/users/userBy/phone/${phone}`)
    //         .then(res => res.json())
    //         .then(data => )
    // },[phone])

    return (
        <div 
        // style={{margin:'8rem'}}
        >
            <h1>EFTYKHAR RAHMAN</h1>
            {/* <h1>User's phone is {phone}</h1> */}
        </div>
    );
};

export default User;